import React from 'react';

export const news = [
  {
    title: '陈文颖老师当选第十八届"良师益友"',
    date: '2023-12-28',
    content: `清华大学第十八届"良师益友"评选结果揭晓，清华大学能源环境经济研究所（3E研究所）陈文颖老师获此荣誉。

清华大学"良师益友"评选是研究生会于1998年发起的活动，由广大研究生同学投票选出心目中"立德为首，学高为师，教益为友，育人为本"的优秀教师代表。第十八届"良师益友"评选活动最终39个院系的47位教师当选。`,
    link: 'https://mp.weixin.qq.com/s/idgs5gxD7uDNuAXaSFsT7w'
  }
];

export default function News() {
  return (
    <div className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">新闻动态</h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
          </p>
        </div>
        <div className="mx-auto mt-10 space-y-12 divide-y divide-gray-200">
          {news.map((item) => (
            <article key={item.title} className="pt-12">
              <div className="flex items-center gap-x-4 text-xs">
                <time dateTime={item.date} className="text-gray-500">
                  {item.date}
                </time>
              </div>
              <h3 className="mt-2 text-lg font-semibold text-gray-900">
                {item.title}
              </h3>
              <p className="mt-4 text-sm text-gray-600 whitespace-pre-line">{item.content}</p>
              {item.link && (
                <div className="mt-4">
                  <a 
                    href={item.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-sm text-indigo-600 hover:text-indigo-500"
                  >
                    阅读更多 →
                  </a>
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}